//Account Transaction Table

export const TRANSACTION = "TRANSACTION"
export const TRANSACTION_SUCCESS = "TRANSACTION_SUCCESS"
export const TRANSACTION_FAIL = "TRANSACTION_FAIL"
export const CLEAR_TRANSACTION = "CLEAR_TRANSACTION"
export const CHANGE_TRANSACTION = "CHANGE_TRANSACTION"
